export type PatternValidationRule = {
    pattern: RegExp;
    message: string;
};

const REA_PATTERN = /^ES(0[1-9]|[1-4][0-9]|5[0-2])[0-9]{3}[0-9]{7}$/;
const ROPO_PATTERN = /^[0-9]{8,12}[A-Z]{2}(\/[0-9]{1,3})?$/;
const ROMA_PATTERN = /^[0-9]{12}$/;

const REA_MESSAGE = 'El código REA debe tener formato ES + provincia + 3 dígitos + 7 dígitos.';
const ROPO_MESSAGE = 'El ROPO debe tener 8-12 números, 2 letras mayúsculas y opcionalmente / + 1-3 números.';
const ROMA_MESSAGE = 'El ROMA debe contener exactamente 12 dígitos.';

/**
 * Resolves official registry-code validation rules from field names or labels.
 */
export function getRegistryCodeValidationRule(
    name: string | undefined,
    label: string | undefined,
): PatternValidationRule | null {
    const normalizedName = String(name ?? '').trim().toLowerCase();
    const normalizedLabel = normalizeLabel(label);

    if (normalizedName === 'codigo_rea' || normalizedLabel === 'REA') {
        return { pattern: REA_PATTERN, message: REA_MESSAGE };
    }

    if (normalizedName === 'roma' || normalizedLabel === 'ROMA') {
        return { pattern: ROMA_PATTERN, message: ROMA_MESSAGE };
    }

    if (normalizedName === 'ropo' || normalizedName.startsWith('ropo_') || normalizedLabel.includes('ROPO')) {
        return { pattern: ROPO_PATTERN, message: ROPO_MESSAGE };
    }

    return null;
}

function normalizeLabel(label: string | undefined): string {
    return String(label ?? '')
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase();
}
